import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RepeatTransactionActionModalUI from './RepeatTransactionActionModalUI'

class RepeatTransactionActionModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      actionType: props.initialActionType || 'approve',
      remark: '',
      submitted: false,
      errorList: null
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({
        actionType: this.props.initialActionType || 'approve',
        remark: (this.props.item && (this.props.item.remarks || this.props.item.remark || this.props.item.rejectionReason)) || '',
        submitted: false,
        errorList: null
      })
    }
  }

  render() {
    return (
      <RepeatTransactionActionModalUI
        context={this.props.context}
        isOpen={this.props.isOpen}
        item={this.props.item}
        actionType={this.state.actionType}
        onActionTypeChange={(type) => this.setState({ actionType: type, errorList: null })}
        remark={this.state.remark}
        onRemarkChange={(val) => this.setState({ remark: val, errorList: null })}
        errorList={this.state.errorList}
        setErrorList={(errList) => this.setState({ errorList: errList })}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  onSubmit = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    if (this.state.submitted || !this.props.item) return

    const offerId = this.props.item.id ||
      this.props.item.offerId ||
      (this.props.item.loanEntity && (this.props.item.loanEntity.id || this.props.item.loanEntity.loanId)) ||
      this.props.item.loanId ||
      this.props.item.accountId

    if (this.state.actionType === 'reject' && !this.state.remark.trim()) {
      this.setState({ errorList: ['Please specify a reason for rejection'] })
      return
    }

    this.setState({ submitted: true, errorList: null })

    const payload = {
      action: this.state.actionType,
      remarks: this.state.remark.trim(),
      remark: this.state.remark.trim(),
      rejectionReason: this.state.remark.trim()
    }

    const endpoint = this.state.actionType === 'reject'
      ? `/api/su/loan/repeatloan/offers/${offerId}/reject`
      : `/api/su/loan/repeatloan/offers/${offerId}/approve`

    RestApiUtils.post(
      this.props.context,
      endpoint,
      this.onSubmitCallback,
      payload
    )
  }

  onSubmitCallback = (response) => {
    if (!response || (response.errorList && response.errorList.length > 0)) {
      this.setState({
        submitted: false,
        errorList: (response && response.errorList) || ['Failed to update repeat loan offer']
      })
      return
    }

    this.setState({ submitted: false, errorList: null }, () => {
      if (this.props.onSuccess) {
        this.props.onSuccess(this.props.item, this.state.actionType, this.state.remark)
      }
    })
  }
}

export default RepeatTransactionActionModalSF
